<template>
    <div class="eng-content">
        <!-- title -->
        <h1 class="main-title">
            <span v-html="$t('engineeringConsulting.title')" class='title-span'>
                <hr style="width:50%">
            </span>
        </h1>
        <div class="row">
            <p>{{$t('engineeringConsulting.introText')}}</p>
        </div>
        
        <!-- PROTOTYPING -->
        <!-- <div class="sevices-row" style="display:none">
            <div class="row">
                <div class="col-sm-6 sevice-left">
                    <div class="sevice-img-box">
                        <img class="img-responsive" src="../../assets/images/tom-claes-hMP2mme5yG0-unsplash.png" alt="">
                    </div>
                </div>
                <div class="col-sm-6 sevice-content">
                    <h1>PROTOTYPING</h1>
                    <ul>
                        <li v-for="(item,index) in proIcon" :key="index">
                            <img class="img-responsive" :src="item.url" alt="">
                            <span>{{item.title}}</span>
                        </li>
                    </ul>
                    <p>
                        MPT Solution’s prototyping center provides all kinds of high resolution rapid prototyping solutions, such as CNC, 3D printing, Urethane casting, and thermoforming etc.
                    </p>
                    <router-link class="btn" to="/Prototyping">Learn More</router-link>
                </div>
            </div>
        </div> -->
    
        <div class="row eng-row">
            <ul class="pic-list">
                <li v-for="(item,index) in engconPic[$i18n.locale]" :key="index">
                    <img :src="item.imgUrl" alt="">
                    <h1>{{item.title}}</h1>
                    <p v-html="item.text">{{item.text}}</p>
                </li>
            </ul>
        </div>

        

        <!-- TEAMS -->
        <!-- <div class="teams-row">
            <div class="row">
                <h1>TRUSTED BY WORLD'S LEADING TEAMS</h1>
                <ul>
                    <li v-for="(item,index) in teamsImg" :key="index">
                        <img :src="item.url">
                    </li>
                </ul>
            </div>
        </div> -->

    </div>
</template>

<script>
    export default {
        data() {
            return {
                engconPic:'',
                // proIcon:[
                //     {
                //         url:require('../../assets/images/CNC.png'),
                //         title:"CNC"
                //     },{
                //         url:require('../../assets/images/3D Printer.png'),
                //         title:"3D PRINTING"
                //     },{
                //         url:require('../../assets/images/outline.png'),
                //         title:"URETHANE CASTING"
                //     }
                // ],
                teamsImg:[
                    {url:require('../../assets/images/Dell_logo_2016.png')},
                    {url:require('../../assets/images/Nvidia-logo-01.png')},
                    {url:require('../../assets/images/group_28.png')}
                ]
            }
        },
        methods:{
            getEngconPic(){
                this.$api.engcon.engconPic().then(res=>{
                    this.engconPic = res.data.result
                    console.log(res.data.result)
                }).catch(
                    (error) => {
                        console.log(error)
                    }
                )
            }
        },
        mounted(){
            $(document).ready(function(){
                if($(window).width()>768){
                    $(".sevice-img-box").height($(".sevice-content").height());
                }
            })
            this.getEngconPic();
        }
    }
</script>

<style scoped>
    .eng-title-text{
        overflow: hidden;
    }
    .eng-title-text p{
        float: left;
        width: 33.3333333%;
        text-align: left;
        margin-right: 2rem;
        font-size: 1.6rem;
        height:20rem;
    }
    .sevices-row{
        width:100%;
        background:#091932;
        padding:2rem 0;
    }
    .sevices-row h1{
        font-size: 4.8rem;
        color:#fff;
        font-weight: 700;
        text-align: left;
    }
    .sevices-row p{
        width: 100%;
        color:#fff;
        font-size: 2rem;
        text-align: left;
        margin:4rem 0;
    }
    .sevice-content{
        padding-left: 8rem;
    }
    .sevices-row ul{
        margin-top:4rem
    }
    .sevices-row ul li{
        overflow: hidden;
        margin-top: 2rem;
    }
    .sevices-row ul li img{
        float: left;
        width:6rem;
        margin: 0 auto;
    }
    .sevices-row ul li span{
        float: left;
        font-size: 1.4rem;
        font-weight: bold;
        color: #fff;
        margin-top: 2rem;
        margin-left: 2rem;
    }
    .sevice-img-box{
        display: table-cell;
        vertical-align: middle;
        width: 100%;
    }
    .sevice-img-box img{
        padding:25px;
        background: #fff;
        width: 100%;
    }
    .pro-row{
        width:100%;
        background:#091932;
        padding:2rem 0;
    }
    .pro-row h1{
        font-size: 3rem;
        color:#fff;
        font-weight: 700;
        text-align: left;
    }
    .pro-row p{
        width: auto;
        color:#fff;
        font-size: 1.4rem;
        text-align: left;
        line-height: 2rem;
        height:8rem;
        overflow: hidden;
        margin:2rem 0;
    }
    .pro-row ul{
        overflow: hidden;
    }
    .pro-row ul li{
        float:left;
        width:33.33333%;
        margin-top: 2rem;
    }
    .pro-row ul li img{
        display: block;
        width:30%;
        margin: 0 auto;
    }
    .pro-row ul li span{
        display: block;
        font-size: 1.4rem;
        font-weight: bold;
        color: #fff;
        margin-top: 2rem;
    }
    .teams-row{
        width:100%;
        background:#E9E9E9;
    }
    .teams-row .row{
        margin-top: 0;
    }
    .teams-row h1{
        font-size: 2rem;
        font-weight: 700;
        margin:4rem 0;
    }
    .teams-row ul{
        overflow: hidden;
        margin-bottom: 1.5rem;
    }
    .teams-row ul li{
        float: left;
        width:33.3333333%;
        text-align: center;
    }
    .teams-row ul li img{
        max-width:100%;
        height: auto;
    }
    .title-span{ 
        border-bottom: 3px solid #0099FF;padding-bottom: 1px;
    }
    @media (max-width: 767px){
        .eng-content .main-title{
            font-size: .8rem;
        }
        .eng-title-text p{
            float: initial;
            width: auto;
            text-align: left;
            font-size: .7rem;
            height:auto;
            margin-bottom: 1rem;
            margin-right: 0;
        }
        .sevices-row .row{
            margin:0 auto;
        }
        .sevice-content{
            padding-left: 15px;
        }
        .sevices-row h1{
            text-align: center;
            font-size: 1.5rem;
            margin-top: 1rem;
        }
        .sevices-row .row p{
            font-size: 0.7rem;
            margin:1rem 0;
            padding:0;
        }
        .sevices-row .btn{
            margin:1rem auto
        }
        .sevices-row ul{
            margin-top: 2rem;
            padding-left: 2rem;
            margin-bottom: 2rem;
        }
        .sevices-row ul li{
            margin-top: 1rem;
        }
        .sevices-row ul li img{
            width: 3rem;
        }
        .sevices-row ul li span{
            font-size: 0.7rem;
            margin-top: 1rem;
        }
        .pro-row .row{
            margin:0 auto;
        }
        .pro-row h1{
            text-align: center;
            font-size: 1.5rem;
        }
        .pro-row p{
            font-size: 0.7rem;
            height:auto;
            line-height: 1.5;
            margin:1rem 0
        }
        .pro-row .btn{
            margin:1rem auto
        }
        .pro-row ul li span{
            font-size: 0.7rem;
        }
        .teams-row h1{
            font-size: 0.8rem;
            margin:2rem 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Services/EngineeringConsulting.vue